import { render, staticRenderFns } from "./businessSet.vue?vue&type=template&id=0bfbfd5a&"
import script from "./businessSet.vue?vue&type=script&lang=js&"
export * from "./businessSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports